import { Column, HeaderFilter } from "devextreme-react/data-grid"
import { InstructionalVideoWatchLogDto } from "../../model/watchLogDto"
import { t } from "i18next"
import DateTimeLocal from "../../../../core/components/typography/DateTimeLocal"
import { useWatchStates } from "../../hook/useWatchStates"
import { GenericDataGrid } from "../../../../core/components"

interface StatisticDetailProps {
    userWatchLogs: InstructionalVideoWatchLogDto[]
}

export default function StatisticDetail(props: StatisticDetailProps) {
    const { watchStatesLookup } = useWatchStates()

    return <GenericDataGrid
        id={""}
        rowKey={"HMM"}
        data={props.userWatchLogs}
        className="compact"
        columnHidingEnabled={false}
        borderRadius="small">
        <HeaderFilter visible={false} />
        <Column
            dataField="userDisplayName"
            caption={t("User")} />
        <Column
            dataField="state"
            caption={t("State")}
            minWidth={100}
            lookup={watchStatesLookup} />
        <Column
            dataField="watchedDuration"
            caption={t("Watched Duration")}
            width={200} />
        <Column
            dataField="watchStartedUtc"
            caption={t("Started At")}
            width={200}
            cellRender={e => <DateTimeLocal dateTimeUtc={e.data.watchStartedUtc} />} />
        <Column
            dataField="watchFinishedUtc"
            caption={t("Finished At")}
            width={200}
            cellRender={e => <DateTimeLocal dateTimeUtc={e.data.watchFinishedUtc} />} />
    </GenericDataGrid>
}
